/**
 * Tracks duel cards the user has dismissed via swipe-left on mobile browse.
 * Persists for the current tab session only — sessionStorage so a tab close
 * gives a fresh slate, but in-tab refreshes preserve the dismissed state.
 */

const KEY = 'beatduel_dismissed_duels';

function read(): Set<number> {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr.filter((v) => typeof v === 'number') : []);
  } catch {
    return new Set();
  }
}

function write(ids: Set<number>): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(Array.from(ids)));
  } catch {
    // sessionStorage full or disabled — silently no-op.
  }
}

export function getDismissedDuelIds(): Set<number> {
  return read();
}

export function dismissDuel(id: number): void {
  const set = read();
  set.add(id);
  write(set);
}

export function clearDismissedDuels(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // no-op
  }
}

export function filterDismissed<T extends { id: number }>(items: T[]): T[] {
  const dismissed = read();
  if (dismissed.size === 0) return items;
  return items.filter((d) => !dismissed.has(d.id));
}
